export default __webpack_public_path__ + "assets/Team.b596.svg";